import axios from 'axios';
import Cookie from 'js-cookie';

const clientapi = axios.create( {
    baseURL: import.meta.env.TWC_API_URL,
    validateStatus: function( status ) {
        return true;
    },
} );

const refreshClientToken = async () => {
    let ref_token = Cookie.get( 'refresh_token' );

    // if there is no refresh token, we need to logout
    if ( !ref_token ) {
        window.location = '/logout';
        return false;
    }

    const response = await axios.post( import.meta.env.TWC_AUTH_URL + '/token/refresh', null, {
        headers: {
            Authorization: `Bearer ${ref_token}`,
        },
    } ).catch( ( error ) => {
        window.location = '/logout';
        return false;
    } );

    if ( response.status === 401 ) {
        window.location = '/logout';
        return false;
    }

    if ( response.status === 200 ) {
        let { accessToken } = response.data;
        Cookie.set( 'access_token', accessToken, { expires: 3,
            sameSite: 'Strict' } );
        return true;
    }

    return false;
};

let handleRequest = async ( request ) => {
    const token = Cookie.get( 'access_token' );

    if ( token ) {
        request.headers.Authorization = `Bearer ${token}`;
    }

    return request;
};

let handleResponse = async ( response ) => {
    const status = response.status;

    // unathorized (try to refresh token?)
    if ( status === 401 ) {
    // check if we already tried
        if ( response.config._retry ) {
            return response;
        }

        if ( await refreshClientToken() ) {
            response.config._retry = true;
            return clientapi.request( response.config );
        }
    }

    return response;
};

const handleError = ( error ) => {
    return Promise.reject( error );
};

clientapi.interceptors.request.use( handleRequest, handleError );
clientapi.interceptors.response.use( handleResponse, handleError );

export { clientapi, refreshClientToken };
